@if (!isLoading) {
  <div class="terms-container flex flex-column">
    <div class="title mt-4">Termos de Uso</div>
    <p-panel>
      <p-scrollPanel [style]="{width: '100%', height: '500px'}">
        <div [innerHTML]="termOfUse.content"></div>
      </p-scrollPanel>
    </p-panel>
    <div class="check-container flex flex-row gap-3">
      <p-checkbox [(ngModel)]="accepted" [binary]="true" inputId="text"/>
      <label for="text">Li e estou de acordo com o Termo de Uso e Política de Privacidade</label>
    </div>
    <div class="btn-bar flex flex-row justify-content-between md:justify-content-end sm:justify-content-end gap-3">
      <p-button class="secondary-btn" label="Voltar" icon="pi pi-times" (click)="cancel()"></p-button>
      <p-button class="primary-btn" label="Aceitar" icon="pi pi-check" [disabled]="!accepted" (click)="postTermAcceptance()"></p-button>
    </div>
  </div>
} @else{
  <div class="terms-container flex flex-column gap-3" >
    <p-skeleton class="title mt-4" width="15%" height="2rem" />
    <p-skeleton width="100%" height="500px" />
    <p-skeleton width="40%" height="1rem" />
    <p-skeleton class="flex flex-row justify-content-end" width="25%" height="3rem" />
  </div>
}
